import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { MaskedLines } from "./MaskedLines";
import { IMAGES, EASE } from "./constants";

const CHAPTERS = [
  {
    n: "01",
    title: "Radici a Milano",
    body: "Alba Immobili nasce in Via Cenisio 40, nel cuore pulsante di Milano. Non siamo una vetrina anonima: siamo persone che vivono la città, ne conoscono i quartieri e ne interpretano il valore.",
  },
  {
    n: "02",
    title: "Al fianco di chi vende",
    body: "Vendere la propria casa è una decisione importante. Ti accompagniamo con trasparenza, dalla prima valutazione fino al rogito, tutelando il tuo tempo e il tuo patrimonio.",
  },
  {
    n: "03",
    title: "Il giusto acquirente",
    body: "Grazie a una rete selezionata e a una strategia su misura, presentiamo il tuo immobile solo a chi è realmente interessato, ottenendo il miglior prezzo di mercato.",
  },
];

export const Manifesto = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-15%" });

  return (
    <section id="chi-siamo" ref={ref} data-testid="manifesto-section" className="py-24 md:py-36 max-w-[1500px] mx-auto px-6 md:px-12 lg:px-16">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-12 gap-x-10 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-32">
          <div className="overline text-[#21463E] mb-6 flex items-center gap-3">
            <span className="h-px w-8 bg-[#21463E] inline-block" /> Chi Siamo
          </div>
          <h2 className="font-serif font-light text-[#2E3131] text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            <MaskedLines inView={inView} lines={["Un'agenzia", "fatta di", <em key="e" className="italic text-[#21463E]">persone.</em>]} />
          </h2>

          <motion.div
            initial={{ opacity: 0, clipPath: "inset(0 0 100% 0)" }}
            animate={inView ? { opacity: 1, clipPath: "inset(0 0 0% 0)" } : {}}
            transition={{ duration: 1.1, delay: 0.5, ease: EASE }}
            className="mt-10 aspect-[4/5] w-full max-w-sm overflow-hidden rounded-2xl"
          >
            <img src={IMAGES.interiorWarm} alt="Interno di pregio a Milano" className="h-full w-full object-cover hover:scale-105 transition-transform duration-[1.2s] ease-out" />
          </motion.div>
        </div>

        <div className="lg:col-span-7 lg:col-start-6 flex flex-col">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.3 + i * 0.15, ease: EASE }}
              className="grid grid-cols-[auto_1fr] gap-6 md:gap-10 py-10 border-b border-[#DBDBDA] last:border-b-0"
            >
              <span className="font-serif text-5xl md:text-7xl text-[#21463E]/30 leading-none select-none">{c.n}</span>
              <div>
                <h3 className="font-serif text-2xl md:text-3xl text-[#2E3131] mb-3">{c.title}</h3>
                <p className="text-[#5C6360] text-base md:text-lg leading-relaxed max-w-xl">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
